import 'vue-hash-calendar/lib/vue-hash-calendar.css';
import './components/echarts/index.js';
// 手机适配
import './assets/scripts/mobileAdaptive';
import './utils/filter';
import './utils/directive';
import './axios';
// import 'babel-polyfill'
// import './assets/scripts/zs/zs_bridge'
import './assets/iconfont/icon/iconfont.css';
import './assets/iconfont/img/iconfont.js';
import './assets/iconfont/topic/iconfont.css';
import './style/main.less';
import './assets/icons';

import { IrstoreTracker, Tracker } from './utils/tracker';

import { $comein } from './assets/scripts/WebNative';
import App from './App.vue';
import DatePickerScroll from 'vue-datepicker-scroll';
//
import ElementResizeDetectorMaker from 'element-resize-detector';
import Vue from 'vue';
import NativeApp from './utils/app';
Vue.use(NativeApp);
// 复制
import VueClipboard from 'vue-clipboard2';
import VueLazyLoad from 'vue-lazyload';
// 触屏事件，官方地址：https://github.com/vuejs/vue-touch/tree/next
import VueTouch from 'vue-touch';
import VueWorker from 'vue-worker';
import appointDialog from './components/m-appoint-fail-dialog';
// 加载第三方合作组件
import bridge from './thirdparty/scripts/bridge';
// 加载App通讯组件
import comeinApp from './utils/app';
import fetch from './fetch';
import gc from './components/global';
import i18n from './assets/js/i18n';
// // 开启vConsole
import { isVConsole } from './utils/api';
import keepAlive from './router/keepAlive';
// moment.js
import moment from 'moment';
import { proxyNavigateTo } from './utils/navigateTo';
import router from './router';
import store from './store';
import to from 'await-to-js';
import vueHashCalendar from 'vue-hash-calendar';


Vue.use(appointDialog);

if (window.CSS && window.CSS.supports && window.CSS.supports('scroll-behavior', 'smooth')) {
	window._supportSmooth_ = true;
}

Vue.use(VueTouch, { name: 'v-touch' });

// 注册 vue-worker
Vue.use(VueWorker);

Vue.use(VueClipboard);

Vue.use(vueHashCalendar);

// 注册全局组件
Vue.use(gc);

// 注册该文件夹下所有的svg文件
const request = require.context('./assets/icons', false, /\.svg$/);
request.keys().forEach(request);

// 提供异步请求方法 fetch
// window.originFetch = window.fetch;
window.comeinFetch = fetch;

Vue.use(DatePickerScroll);

// app分享的shareData
window.shareData = {};
window.extraDataMap = {};

// 图片懒加载，及配置
Vue.use(VueLazyLoad);

window.$comein = $comein;
// app内第三方调用接口
$comein.register('MDljNWUxZTAtMTk4OS00MDQ4LTkwOTYtNTc4YWU3YTkwZjJj');

Vue.use(bridge);

if (isVConsole) {
	let VConsole = require('vconsole');
	new VConsole();
}

Vue.prototype.$moment = moment;

Vue.prototype.$track = Tracker;
Vue.prototype.$irTrack = IrstoreTracker;

Vue.prototype.$to = to;

Vue.prototype.$erd = ElementResizeDetectorMaker();

Vue.use(comeinApp);

Vue.config.productionTip = false;
Vue.config.ignoredElements = ['wx-open-launch-weapp'];

Vue.mixin({
	...keepAlive
});

Vue.prototype.$navigateTo = proxyNavigateTo;

/* eslint-disable no-new */
new Vue({
	router,
	store,
	i18n,
	render: h => h(App)
}).$mount('#root');
